import React from 'react'

const ServiceHighlights = () => {
  const servobj = [
    {
      id: 1,
      lable: "Cutting Edge and Functional Websites",
    },
    {
      id: 2,
      lable: "Intelligent and Attractive Applications",
    },
    {
      id: 3,
      lable: "Far Reaching Marketing Campaigns",
    },
    {
      id: 4,
      lable: "Intelligent Marketing Strategies",
    },
    {
      id: 5,
      lable: "24X7 Customer Support",
    },
    {
      id: 6,
      lable: "Professional Approach & Prompt Communication",
    },
    {
      id: 7,
      lable: "Experienced, Skilled Designers & Programmers",
    },
    {
      id: 8,
      lable: "Game Development",
    },
    {
      id: 9,
      lable: "Block Chain Development",
    },
    {
      id: 10,
      lable: "Business Intelligence",
    },
    {
      id: 11,
      lable: "Digital Marketing",
    },
  ]
  return (
    <>
      <section>
        <div className="container">
          <h3 className="mb-3 mt-4 fontkumbh">Our Service Highlights</h3>
          <div className="row our-serv-h">
            {servobj.map((servcard) => {
              return <div className="col-lg-4 col-md-4" key={servcard.id}>
                <label>
                  <i data-feather="check-circle" style={{ height: 16 }} /> {servcard.lable}
                </label>
              </div>
            })}

          </div>
        </div>
      </section>
    </>
  )
}

export default ServiceHighlights